module.exports = __webpack_public_path__ + "static/media/golfer-2-b.8c76e58d.png";